import { render, staticRenderFns } from "./WordSaturationPopup.vue?vue&type=template&id=5e1fd0f0&scoped=true"
import script from "./WordSaturationPopup.vue?vue&type=script&lang=js"
export * from "./WordSaturationPopup.vue?vue&type=script&lang=js"
import style0 from "./WordSaturationPopup.vue?vue&type=style&index=0&id=5e1fd0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fd0f0",
  null
  
)

export default component.exports